import { compact, map } from 'lodash';
import { toUUID } from '../../util/transform';
import { DocType } from '../global/Doc.enum';
import Root from '../Root';
import Stage from '../stage/Stage';
import type { IStage } from '../stage/Stage.interface';
import { WorkflowType } from './Workflow.enum';
import type { IWorkflow } from './Workflow.interface';

export default class Workflow extends Root implements IWorkflow {
  idTeamMembers: Array<string>;
  type: WorkflowType;
  name: string;
  description: string;
  stages: Array<IStage>;
  isProject: boolean;

  getName() {
    return this.name;
  }

  getDescription() {
    return this.description;
  }

  getType() {
    return this.type;
  }

  isNoType() {
    return this.type.name === WorkflowType.none.name;
  }

  isAssetFinance() {
    return this.type.name === WorkflowType.asset_finance.name;
  }

  isHomeLoan() {
    return this.type.name === WorkflowType.home_loan.name;
  }

  isInsurance() {
    return this.type.name === WorkflowType.insurance.name;
  }

  isCommercialLoan() {
    return this.type.name === WorkflowType.commercial_loan.name;
  }

  isPersonalLoan() {
    return this.type.name === WorkflowType.personal_loan.name;
  }

  isConveyancing() {
    return this.type.name === WorkflowType.conveyancing.name;
  }

  isRealEstate() {
    return this.type.name === WorkflowType.real_estate.name;
  }

  isRiskInsurance() {
    return this.type.name === WorkflowType.risk_insurance.name;
  }

  isProjectView() {
    return this.isProject === true;
  }

  static build = (data: IWorkflow) => new Workflow(data);
  static blank = () => new Workflow({ isActive: true });

  /**
   * Constructor
   * @param {IWorkflow} data
   */
  constructor(data?: IWorkflow) {
    super(DocType.of('__definition.workflow'), data);

    this.idTeamMembers = compact(map(data?.idTeamMembers, (obj) => toUUID(obj)));
    this.stages = map(data?.stages, (obj) => new Stage(obj));
    // TODO: data?.type is legacy data structure
    this.type = WorkflowType.of(data?.type?.name || data?.type);
    // TODO: data?.type is legacy data structure
    this.name = data?.name || '';
    this.description = data?.description || '';
    this.isProject = data?.isProject === true;
  }
}
